module.exports = {
    appVersion: 'process.env.APP_VERSION'.replace(/"/g, ''),
};



// WEBPACK FOOTER //
// ./src/env.js